import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { FormProvider, useForm as ReactHookFormUseForm, } from 'react-hook-form';
import * as styles from './Form.module.scss';
const Name = 'Form';
export const Form = (props) => {
    const { definition, onSubmit, onError, className, children } = props;
    const { handleSubmit } = definition;
    const formDefinition = {
        revalidateMode: 'onBlur',
        ...definition,
    };
    return (_jsx(FormProvider, { ...formDefinition, children: _jsx("form", { className: clsx(styles.container, className), onSubmit: onSubmit && handleSubmit(onSubmit, onError), "data-component": Name, children: children }) }));
};
export const useForm = ReactHookFormUseForm;
